/* src/app/modules/institutions/institutions-tourneemaster/institutions-tourneemaster.component.scss */
/*# sourceMappingURL=institutions-tourneemaster.component.css.map */
